const PersonalityList = [
    "Adventurous",
    "Affectionate",
    "Ambitious",
    "Amiable",
    "Amusing",
    "Brave",
    "Bright",
    "Brilliant",
    "Calm",
    "Charming",
    "Chatty",
    "Cheerful",
    "Clever",
    "Compassionate",
    "Considerate",
    "Convivial",
    "Cool",
    "Courageous",
    "Creative",
    "Cunning",
    "Decisive",
    "Dependable",
    "Determined",
    "Devious",
    "Diligent",
    "Diplomatic",
    "Dynamic",
    "Easy-going",
    "Effervescent",
    "Efficient",
    "Energetic",
    "Enthusiastic",
    "Fair-minded",
    "Fearless",
    "Friendly",
    "Funny",
    "Generous",
    "Giving",
    "Gregarious",
    "Hardworking",
    "Helpful",
    "Hilarious",
    "Honest",
    "Humorous",
    "Imaginative",
    "Impartial",
    "Independent",
    "Innocent",
    "Intuitive",
    "Inventive",
    "Kind",
    "Kooky",
    "Laid-back",
    "Likeable",
    "Loyal",
    "Modest",
    "Naive",
    "Noble",
    "Non-judgemental",
    "Observant",
    "Optimistic",
    "Organised",
    "Passionate",
    "Patient",
    "Perfect",
    "Persistent",
    "Pliable",
    "Plucky",
    "Poetic",
    "Polite",
    "Powerful",
    "Practical",
    "Proactive",
    "Quick-witted",
    "Reliable",
    "Resourceful",
    "Romantic",
    "Rule-breaking",
    "Sassy",
    "Self-disciplined",
    "Sincere",
    "Smart",
    "Sophisticated",
    "Straight-forward",
    "Sweet",
    "Sympathetic",
    "Talented",
    "Thoughtful",
    "Tidy",
    "Tricky",
    "Trustworthy",
    "Unassuming",
    "Understanding",
    "Versatile",
    "Vivacious",
    "Warmhearted",
    "Wicked",
    "Willing",
    "Witty"
];

class Personality {

    getRandomAdjective() {
        let index = Math.floor(Math.random() * (PersonalityList.length)); // The maximum is inclusive and the minimum is inclusive
        return PersonalityList[index].toLowerCase();
    }

}

export default new Personality();


// WEBPACK FOOTER //
// ./src/words/Personality.js